const rootArea = "/effective";

export const effectiveGlob = (baseArea: string) => ({
	self: `${baseArea}${rootArea}`,
	byCode: (effectiveCode: string) => ({ 					
		read: `${baseArea}${rootArea}/${effectiveCode}/read`,
		create: `${baseArea}${rootArea}/${effectiveCode}/create`,
		update: `${baseArea}${rootArea}/${effectiveCode}/update`,
		delete: `${baseArea}${rootArea}/${effectiveCode}/delete`
	})
});